class PopupMessage {
	constructor(config) {
		this.config = Object.assign({
			scope: '#popupMessage'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		if (this.showPopup()) {
			this.$scope.modal('show');
			this.$scope.on('hide.bs.modal', ()=>{
				sessionStorage.setItem('popupMessageDismissed', this.$scope.data('time'));
			});
		}

	}

	showPopup() {
		return sessionStorage.getItem('popupMessageDismissed') != this.$scope.data('time');
	}
}

export default PopupMessage;